const BasicArcherSideScreen = () => {
  return (
    <div className="bg-light w-full flex items-center justify-center">
      <img src="/assets/images/logo-default.svg" alt="Archer" />
    </div>
  )
}

export default BasicArcherSideScreen
